import React from "react"
import { useLocation } from "react-router-dom"
import { Inspections } from "./components"
import OverviewVariableFees from "./components/OverviewVariableFees"
import OverviewFixedFees from "./components/OverviewFixedFees"
import OverviewMarginValuation from "./components/OverviewMarginValuation"
import { MODULE_VO_TAB_PANE_IDS, parseModuleVOTab } from "./moduleVoNavigation"
import Utils from "../../Utils"

const INSPECTIONS_PANE_ID = 'gestionExpertises'

export default function ModuleVO() {
    const location = useLocation()
    const hasInspectionsTab = !Utils.isAccesClient()

    // Les pages de frais renvoient ici avec ?tab=... pour réafficher l'onglet d'où l'on vient.
    const requestedTab = parseModuleVOTab(new URLSearchParams(location.search).get('tab'))
    const activePaneId = requestedTab
        ? MODULE_VO_TAB_PANE_IDS[requestedTab]
        : (hasInspectionsTab ? INSPECTIONS_PANE_ID : MODULE_VO_TAB_PANE_IDS.variableFees)

    const navLinkClassName = (paneId: string) => `nav-link${paneId === activePaneId ? ' active' : ''}`
    const tabPaneClassName = (paneId: string) => `tab-pane fade${paneId === activePaneId ? ' show active' : ''}`

    return (
        <div className="container-fluid bm-4">
            <h2>Configuration Module VO</h2>
            <ul className="nav nav-tabs" id="myTab">
                {hasInspectionsTab &&
                    <li className="nav-item">
                    <a className={navLinkClassName(INSPECTIONS_PANE_ID)} id="gestionExpertises-tab" data-toggle="tab" href="#gestionExpertises" role="tab" aria-controls="gestionExpertises" aria-selected={INSPECTIONS_PANE_ID === activePaneId}>Catalogue
                    des expertises</a>
                    </li>
                }
                <li className="nav-item">
                    <a className={navLinkClassName(MODULE_VO_TAB_PANE_IDS.variableFees)} id="fraisVariables-tab" data-toggle="tab" href="#fraisVariables" role="tab" aria-controls="fraisVariables" aria-selected={MODULE_VO_TAB_PANE_IDS.variableFees === activePaneId}>Frais variables</a>
                </li>
                <li className="nav-item">
                    <a className={navLinkClassName(MODULE_VO_TAB_PANE_IDS.fixedFees)} id="fraisFixes-tab" data-toggle="tab" href="#fraisFixes" role="tab" aria-controls="fraisFixes" aria-selected={MODULE_VO_TAB_PANE_IDS.fixedFees === activePaneId}>Frais fixes</a>
                </li>
                <li className="nav-item">
                    <a className={navLinkClassName(MODULE_VO_TAB_PANE_IDS.marginValuation)} id="marge-tab" data-toggle="tab" href="#marge" role="tab" aria-controls="marge" aria-selected={MODULE_VO_TAB_PANE_IDS.marginValuation === activePaneId}>Marge de la cotation</a>
                </li>
            </ul>
            <div className="tab-content" id="myTabContent" style={{ paddingTop: '15px', paddingLeft: '20px', paddingRight: '20px' }}>
                <div className={tabPaneClassName(INSPECTIONS_PANE_ID)} id="gestionExpertises" role="tabpanel" aria-labelledby="gestionExpertises-tab">
                    <Inspections/>
                </div>
                <div className={tabPaneClassName(MODULE_VO_TAB_PANE_IDS.variableFees)} id="fraisVariables" role="tabpanel" aria-labelledby="fraisVariables-tab">
                    <OverviewVariableFees/>
                </div>
                <div className={tabPaneClassName(MODULE_VO_TAB_PANE_IDS.fixedFees)} id="fraisFixes" role="tabpanel" aria-labelledby="fraisFixes-tab">
                    <OverviewFixedFees/>
                </div>
                <div className={tabPaneClassName(MODULE_VO_TAB_PANE_IDS.marginValuation)} id="marge" role="tabpanel" aria-labelledby="marge-tab">
                    <OverviewMarginValuation/>
                </div>
            </div>
        </div>
    )
}
